// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dashboard_wrapper__I-w0i"};